export const Price = ({
  className,
  energyClass,
  currency,
  isReduced,
  isRecommended,
  isValuePack,
  sellPrice,
  originalPrice,
  priceDifference,
  translations
}) => {
  const currencySign = currency === 'CHF' ? ` CHF` : `€`;
  const uvp = isRecommended ? translations.UVP : ``;
  const energyClassElement =
    energyClass.label !== ''
      ? `
<div class="energy-class energy-class--${energyClass.className} article-full-price__energy-class">${energyClass.label}</div>
`
      : ``;
  const discountPrice = `
<div class="${className.DETAILS.PRICE.DISCOUNT}"> ${uvp} ${originalPrice}${currencySign}</div>
  `;
  const priceDiffElement = `<div>${translations.VALUE_PACK}: <strong>${priceDifference} ${currencySign}</strong></div>`;

  return `
<div class="${className.DETAILS.PRICE.WRAP}">
    ${energyClassElement}
    <div class="${
      isReduced
        ? className.DETAILS.PRICE.STRIKE
        : className.DETAILS.PRICE.NORMAL
    }">${sellPrice}${currencySign}</div>
    ${isReduced ? discountPrice : ''}
</div>
${isValuePack && isReduced ? priceDiffElement : ''}
  `;
};

export default Price;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/components/Details/price.js
 **/